


































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import RegisterInput from "@/components/register/Input.vue";
import RegisterConfirm from "@/components/register/Confirm.vue";
//import config from '../../config'

@Component({
    components:{
        RegisterInput,
        RegisterConfirm,
    }
})
export default class Register extends Vue {
    private inputName  = '';
    private inputKana  = '';
    private inputCompanyName  = '';
    private inputAddress = '';
    private inputPhoneNumber = '';
    private inputConfirm = false;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    getInputConfirm(confirm: boolean){
        this.inputConfirm = confirm;
        //console.log("inputConfirm:".this.inputConfirm);
    }

    public getName(inputName: string) {
        this.inputName = inputName;
    }

    public getKana(inputKana: string) {
        this.inputKana = inputKana;
    }

    public getCompanyName(inputCompanyName: string) {
        this.inputCompanyName = inputCompanyName;
    }

    public getAddress(inputAddress: string) {
        this.inputAddress = inputAddress;
    }

    public getPhoneNumber(inputPhoneNumber: string) {
        this.inputPhoneNumber = inputPhoneNumber;
    }
}
